import { useState } from 'react';
import { useMemoizedFn } from 'ahooks';
import { handleDatas } from '../utils/common';

export default function useDownloadTablePDF(
  queryAllDatasResService: (params: any) => Promise<any>,
  module?: string,
) {
  const [isAllDatasResLoading, setIsAllDatasResLoading] = useState(false);
  const [allDatas, setAllDatas] = useState<orgHeadcountsDataTypes>(null);

  const updateAllDatas = useMemoizedFn(async (params: any) => {
    try {
      setIsAllDatasResLoading(true);
      const res = await queryAllDatasResService?.(params);
      const allDatasResFormatted = handleDatas(res, module);
      if (!allDatasResFormatted?.isSuccessReq) {
        setAllDatas(null);
        return;
      }
      setAllDatas(allDatasResFormatted);
    } catch (exception) {
      console.warn(exception);
    } finally {
      setIsAllDatasResLoading(false);
    }
  });

  return {
    isAllDatasResLoading,
    allDatas,
    updateAllDatas,
  };
}
